// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__38wKg","name":"ConsentHeader_name__GU8tf","birthday":"ConsentHeader_birthday__3CnnE","skeleton":"ConsentHeader_skeleton__1bQsQ"};